import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "tax-rate-remote" }
const _hoisted_2 = { class: "header-actions" }
const _hoisted_3 = { class: "tax-table-container" }
const _hoisted_4 = { class: "tax-table" }
const _hoisted_5 = ["data-tax-id"]
const _hoisted_6 = { class: "year-col" }
const _hoisted_7 = { class: "action-col" }
const _hoisted_8 = {
  key: 0,
  class: "no-data"
}
const _hoisted_9 = {
  colspan: "10",
  class: "text-center"
}

import { ref, nextTick } from 'vue';
import axios from 'axios';

// Props
interface Props {
  showButton?: boolean;
}

interface TaxRate {
  tr_idx?: number;
  tr_year: string;
  tr_yeon: number | string;
  tr_gun: number | string;
  tr_go: number | string;
  tr_jang: number | string;
  tr_san: number | string;
  tr_sil: number | string;
  tr_time_pay: number | string;
  tr_labor_cost_rate: number | string;
  isNew?: boolean;
  isDeleted?: boolean;
  tempId?: string;
  isValid?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'TaxRateRemote',
  props: {
    showButton: { type: Boolean, default: false }
  },
  setup(__props: any, { expose: __expose }) {

const props = __props;

const dialog = ref(false);
const taxRateList = ref<TaxRate[]>([]);
const saving = ref(false);
const snackbar = ref({ 
  show: false, 
  message: '', 
  color: 'success',
  icon: 'mdi-check-circle'
});

const loadTaxRates = async () => {
  try {
    const response = await axios.get('/api/calc/tax-rate');
    if (response.data.success) {
      taxRateList.value = response.data.data.map((t: TaxRate) => ({
        ...t,
        tr_time_pay: formatMoney(t.tr_time_pay || 0),
        isNew: false,
        isDeleted: false,
        isValid: true
      }));
    }
  } catch (error) {
    console.error('세금 요율 조회 실패:', error);
    showSnackbar('세금 요율 조회에 실패했습니다', 'error', 'mdi-alert-circle');
  }
};

const addTaxRate = () => {
  const tempId = `temp_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
  const currentYear = new Date().getFullYear();
  
  const newTaxRate: TaxRate = {
    tr_year: String(currentYear),
    tr_yeon: 0.045,
    tr_gun: 0.03545,
    tr_go: 0.009,
    tr_jang: 0.1281,
    tr_san: 0.007,
    tr_sil: 0.008,
    tr_time_pay: '',
    tr_labor_cost_rate: 0.6,
    isNew: true,
    isDeleted: false,
    tempId,
    isValid: false
  };
  
  taxRateList.value.unshift(newTaxRate);
  
  // 새로 추가된 항목에 포커스
  nextTick(() => {
    const yearInput = document.querySelector(`[data-tax-id="${tempId}"] .year-input input`) as HTMLInputElement;
    if (yearInput) {
      yearInput.focus();
    }
  });
  
  showSnackbar('연도를 추가했습니다', 'info', 'mdi-plus-circle');
};

const validateYear = (tax: TaxRate) => {
  const year = tax.tr_year?.trim();
  tax.isValid = Boolean(year && year.length === 4 && /^\d{4}$/.test(year));
  
  if (year && year.length > 4) {
    tax.tr_year = year.substring(0, 4);
  }
};

// 금액 포맷팅 함수
const formatMoney = (amount: number | string): string => {
  if (!amount && amount !== 0) return '';
  const numericValue = typeof amount === 'string' ? parseFloat(amount.replace(/[^\d]/g, '')) : amount;
  if (isNaN(numericValue)) return '';
  return new Intl.NumberFormat('ko-KR').format(numericValue);
};

// 금액 입력 필드 포커스 이벤트 (컴마 제거)
const onMoneyFocus = (event: FocusEvent, tax: TaxRate, field: string) => {
  const input = event.target as HTMLInputElement;
  const value = input.value;
  const numericValue = value.replace(/,/g, '');
  input.value = numericValue;
  (tax as any)[field] = numericValue;
};

// 금액 입력 필드 포커스 아웃 이벤트 (컴마 추가)
const onMoneyBlur = (event: FocusEvent, tax: TaxRate, field: string) => {
  const input = event.target as HTMLInputElement;
  const value = input.value;
  const numericValue = value.replace(/[^\d]/g, '');
  
  if (numericValue) {
    const formattedValue = formatMoney(parseInt(numericValue));
    input.value = formattedValue;
    (tax as any)[field] = formattedValue;
  } else {
    input.value = '';
    (tax as any)[field] = '';
  }
};

// 금액 입력 필드 입력 이벤트 (숫자만 허용)
const onMoneyInput = (event: Event, tax: TaxRate, field: string) => {
  const input = event.target as HTMLInputElement;
  let value = input.value;
  value = value.replace(/[^\d]/g, '');
  
  if (value.length > 12) {
    value = value.slice(0, 12);
  }
  
  input.value = value;
  (tax as any)[field] = value;
};

// 요율 입력 필드 포커스 이벤트
const onRateFocus = (event: FocusEvent) => {
  const input = event.target as HTMLInputElement;
  input.select();
};

// 요율 입력 필드 포커스 아웃 이벤트
const onRateBlur = (event: FocusEvent, tax: TaxRate, field: string) => {
  const input = event.target as HTMLInputElement;
  const value = parseFloat(input.value);
  
  if (!isNaN(value)) {
    (tax as any)[field] = value;
  } else {
    (tax as any)[field] = 0;
  }
};

// 요율 입력 필드 입력 이벤트
const onRateInput = (event: Event, tax: TaxRate, field: string) => {
  const input = event.target as HTMLInputElement;
  let value = input.value;
  
  // 숫자와 소수점만 허용
  value = value.replace(/[^\d.]/g, '');
  
  // 소수점이 여러 개인 경우 첫 번째만 유지
  const parts = value.split('.');
  if (parts.length > 2) {
    value = parts[0] + '.' + parts.slice(1).join('');
  }
  
  input.value = value;
  (tax as any)[field] = value;
};

const removeTaxRate = (tax: TaxRate) => {
  if (tax.isNew) {
    const index = taxRateList.value.indexOf(tax);
    taxRateList.value.splice(index, 1);
    showSnackbar('세금 요율을 삭제했습니다', 'info', 'mdi-delete');
  } else {
    tax.isDeleted = true;
    showSnackbar('세금 요율을 삭제 목록에 추가했습니다', 'warning', 'mdi-delete-outline');
  }
};

// 숫자 문자열을 숫자로 변환하는 함수
const parseMoneyValue = (value: number | string): number => {
  if (typeof value === 'number') return value;
  if (!value) return 0;
  return parseFloat(String(value).replace(/[^\d]/g, '')) || 0;
};

const parseRateValue = (value: number | string): number => {
  if (typeof value === 'number') return value;
  if (!value) return 0;
  return parseFloat(String(value)) || 0;
};

const saveTaxRates = async () => {
  // 유효성 검사
  const invalidTax = taxRateList.value.filter(t => 
    !t.isDeleted && (!t.tr_year?.trim() || !/^\d{4}$/.test(t.tr_year))
  );
  
  if (invalidTax.length > 0) {
    showSnackbar('연도를 4자리 숫자로 입력해주세요', 'error', 'mdi-alert-circle');
    return;
  }

  saving.value = true;
  try {
    let count = 0;
    const errors: string[] = [];

    // 삭제
    const deletes = taxRateList.value.filter(t => t.isDeleted && t.tr_idx);
    for (const t of deletes) {
      try {
        await axios.delete(`/api/calc/tax-rate/${t.tr_idx}`);
        count++;
      } catch (error) {
        errors.push(`삭제 실패: ${t.tr_year}`);
      }
    }

    // 추가
    const inserts = taxRateList.value.filter(t => t.isNew && !t.isDeleted && t.tr_year.trim());
    for (const t of inserts) {
      try {
        await axios.post('/api/calc/tax-rate', {
          tr_year: t.tr_year,
          tr_yeon: parseRateValue(t.tr_yeon),
          tr_gun: parseRateValue(t.tr_gun),
          tr_go: parseRateValue(t.tr_go),
          tr_jang: parseRateValue(t.tr_jang),
          tr_san: parseRateValue(t.tr_san),
          tr_sil: parseRateValue(t.tr_sil),
          tr_time_pay: parseMoneyValue(t.tr_time_pay),
          tr_labor_cost_rate: parseRateValue(t.tr_labor_cost_rate)
        });
        count++;
      } catch (error) {
        errors.push(`추가 실패: ${t.tr_year}`);
      }
    }

    // 수정
    const updates = taxRateList.value.filter(t => !t.isNew && !t.isDeleted && t.tr_idx);
    for (const t of updates) {
      try {
        await axios.put(`/api/calc/tax-rate/${t.tr_idx}`, {
          tr_year: t.tr_year,
          tr_yeon: parseRateValue(t.tr_yeon),
          tr_gun: parseRateValue(t.tr_gun),
          tr_go: parseRateValue(t.tr_go),
          tr_jang: parseRateValue(t.tr_jang),
          tr_san: parseRateValue(t.tr_san),
          tr_sil: parseRateValue(t.tr_sil),
          tr_time_pay: parseMoneyValue(t.tr_time_pay),
          tr_labor_cost_rate: parseRateValue(t.tr_labor_cost_rate)
        });
        count++;
      } catch (error) {
        errors.push(`수정 실패: ${t.tr_year}`);
      }
    }

    if (errors.length > 0) {
      showSnackbar(`일부 저장 실패: ${errors.length}건`, 'warning', 'mdi-alert');
    } else {
      showSnackbar(`저장 완료! (${count}건 처리)`, 'success', 'mdi-check-circle');
    }
    
    await loadTaxRates();
  } catch (error) {
    console.error('저장 실패:', error);
    showSnackbar('저장 중 오류가 발생했습니다', 'error', 'mdi-alert-circle');
  } finally {
    saving.value = false;
  }
};

const showSnackbar = (message: string, color: string = 'success', icon: string = 'mdi-check-circle') => {
  snackbar.value = { show: true, message, color, icon };
};

// 다이얼로그 열릴 때 데이터 로드
const openDialog = () => {
  dialog.value = true;
  loadTaxRates();
};

// 외부에서 접근 가능하도록 노출
__expose({
  openDialog
});

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.showButton)
      ? (_openBlock(), _createBlock(_component_v_btn, {
          key: 0,
          color: "primary",
          variant: "elevated",
          onClick: openDialog,
          "prepend-icon": "mdi-percent"
        }, {
          default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
            _createTextVNode(" 세금 요율 관리 ", -1)
          ]))]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_v_dialog, {
      modelValue: dialog.value,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((dialog).value = $event)),
      "max-width": "900px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, { class: "dialog-title" }, {
              default: _withCtx(() => [
                _cache[14] || (_cache[14] = _createTextVNode(" 세금 요율 관리 ", -1)),
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  icon: "",
                  variant: "text",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (dialog.value = false))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, null, {
                      default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                        _createTextVNode("mdi-close", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, { class: "dialog-content" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_component_v_btn, {
                    color: "primary",
                    variant: "outlined",
                    onClick: addTaxRate,
                    "prepend-icon": "mdi-plus",
                    class: "add-btn"
                  }, {
                    default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                      _createTextVNode(" 연도 추가 ", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("table", _hoisted_4, [
                    _cache[18] || (_cache[18] = _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", { class: "year-col" }, "연도"),
                        _createElementVNode("th", null, "국민연금"),
                        _createElementVNode("th", null, "건강보험"),
                        _createElementVNode("th", null, "고용보험"),
                        _createElementVNode("th", null, "장기요양"),
                        _createElementVNode("th", null, "산재보험"),
                        _createElementVNode("th", null, "실업급여"),
                        _createElementVNode("th", null, "최저시급"),
                        _createElementVNode("th", null, "인건비비율"),
                        _createElementVNode("th", { class: "action-col" }, "작업")
                      ])
                    ], -1)),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(taxRateList.value, (tax) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: tax.tr_idx || tax.tempId,
                          "data-tax-id": tax.tempId,
                          class: _normalizeClass({ 'is-deleted': tax.isDeleted })
                        }, [
                          _createElementVNode("td", _hoisted_6, [
                            _createVNode(_component_v_text_field, {
                              modelValue: tax.tr_year,
                              "onUpdate:modelValue": ($event: any) => ((tax.tr_year) = $event),
                              variant: "outlined",
                              density: "compact",
                              "hide-details": "",
                              placeholder: "연도",
                              class: "year-input",
                              maxlength: "4",
                              onInput: ($event: any) => (validateYear(tax))
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "onInput"])
                          ]),
                          _createElementVNode("td", null, [
                            _createVNode(_component_v_text_field, {
                              modelValue: tax.tr_yeon,
                              "onUpdate:modelValue": ($event: any) => ((tax.tr_yeon) = $event),
                              type: "text",
                              variant: "outlined",
                              density: "compact",
                              "hide-details": "",
                              placeholder: "0.000",
                              class: "rate-input",
                              onFocus: _cache[1] || (_cache[1] = ($event: any) => (onRateFocus($event))),
                              onBlur: ($event: any) => (onRateBlur($event, tax, 'tr_yeon')),
                              onInput: ($event: any) => (onRateInput($event, tax, 'tr_yeon'))
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "onBlur", "onInput"])
                          ]),
                          _createElementVNode("td", null, [
                            _createVNode(_component_v_text_field, {
                              modelValue: tax.tr_gun,
                              "onUpdate:modelValue": ($event: any) => ((tax.tr_gun) = $event),
                              type: "text",
                              variant: "outlined",
                              density: "compact",
                              "hide-details": "",
                              placeholder: "0.000",
                              class: "rate-input",
                              onFocus: _cache[2] || (_cache[2] = ($event: any) => (onRateFocus($event))),
                              onBlur: ($event: any) => (onRateBlur($event, tax, 'tr_gun')),
                              onInput: ($event: any) => (onRateInput($event, tax, 'tr_gun'))
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "onBlur", "onInput"])
                          ]),
                          _createElementVNode("td", null, [
                            _createVNode(_component_v_text_field, {
                              modelValue: tax.tr_go,
                              "onUpdate:modelValue": ($event: any) => ((tax.tr_go) = $event),
                              type: "text",
                              variant: "outlined",
                              density: "compact",
                              "hide-details": "",
                              placeholder: "0.000",
                              class: "rate-input",
                              onFocus: _cache[3] || (_cache[3] = ($event: any) => (onRateFocus($event))),
                              onBlur: ($event: any) => (onRateBlur($event, tax, 'tr_go')),
                              onInput: ($event: any) => (onRateInput($event, tax, 'tr_go'))
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "onBlur", "onInput"])
                          ]),
                          _createElementVNode("td", null, [
                            _createVNode(_component_v_text_field, {
                              modelValue: tax.tr_jang,
                              "onUpdate:modelValue": ($event: any) => ((tax.tr_jang) = $event),
                              type: "text",
                              variant: "outlined",
                              density: "compact",
                              "hide-details": "",
                              placeholder: "0.000",
                              class: "rate-input",
                              onFocus: _cache[4] || (_cache[4] = ($event: any) => (onRateFocus($event))),
                              onBlur: ($event: any) => (onRateBlur($event, tax, 'tr_jang')),
                              onInput: ($event: any) => (onRateInput($event, tax, 'tr_jang'))
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "onBlur", "onInput"])
                          ]),
                          _createElementVNode("td", null, [
                            _createVNode(_component_v_text_field, {
                              modelValue: tax.tr_san,
                              "onUpdate:modelValue": ($event: any) => ((tax.tr_san) = $event),
                              type: "text",
                              variant: "outlined",
                              density: "compact",
                              "hide-details": "",
                              placeholder: "0.000",
                              class: "rate-input",
                              onFocus: _cache[5] || (_cache[5] = ($event: any) => (onRateFocus($event))),
                              onBlur: ($event: any) => (onRateBlur($event, tax, 'tr_san')),
                              onInput: ($event: any) => (onRateInput($event, tax, 'tr_san'))
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "onBlur", "onInput"])
                          ]),
                          _createElementVNode("td", null, [
                            _createVNode(_component_v_text_field, {
                              modelValue: tax.tr_sil,
                              "onUpdate:modelValue": ($event: any) => ((tax.tr_sil) = $event),
                              type: "text",
                              variant: "outlined",
                              density: "compact",
                              "hide-details": "",
                              placeholder: "0.000",
                              class: "rate-input",
                              onFocus: _cache[6] || (_cache[6] = ($event: any) => (onRateFocus($event))),
                              onBlur: ($event: any) => (onRateBlur($event, tax, 'tr_sil')),
                              onInput: ($event: any) => (onRateInput($event, tax, 'tr_sil'))
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "onBlur", "onInput"])
                          ]),
                          _createElementVNode("td", null, [
                            _createVNode(_component_v_text_field, {
                              modelValue: tax.tr_time_pay,
                              "onUpdate:modelValue": ($event: any) => ((tax.tr_time_pay) = $event),
                              type: "text",
                              variant: "outlined",
                              density: "compact",
                              "hide-details": "",
                              placeholder: "0",
                              class: "money-input",
                              onFocus: ($event: any) => (onMoneyFocus($event, tax, 'tr_time_pay')),
                              onBlur: ($event: any) => (onMoneyBlur($event, tax, 'tr_time_pay')),
                              onInput: ($event: any) => (onMoneyInput($event, tax, 'tr_time_pay'))
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "onFocus", "onBlur", "onInput"])
                          ]),
                          _createElementVNode("td", null, [
                            _createVNode(_component_v_text_field, {
                              modelValue: tax.tr_labor_cost_rate,
                              "onUpdate:modelValue": ($event: any) => ((tax.tr_labor_cost_rate) = $event),
                              type: "text",
                              variant: "outlined",
                              density: "compact",
                              "hide-details": "",
                              placeholder: "0.00",
                              class: "rate-input",
                              onFocus: _cache[7] || (_cache[7] = ($event: any) => (onRateFocus($event))),
                              onBlur: ($event: any) => (onRateBlur($event, tax, 'tr_labor_cost_rate')),
                              onInput: ($event: any) => (onRateInput($event, tax, 'tr_labor_cost_rate'))
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "onBlur", "onInput"])
                          ]),
                          _createElementVNode("td", _hoisted_7, [
                            _createVNode(_component_v_btn, {
                              color: "error",
                              variant: "outlined",
                              onClick: ($event: any) => (removeTaxRate(tax)),
                              icon: "mdi-delete",
                              size: "small"
                            }, null, 8, ["onClick"])
                          ])
                        ], 10, _hoisted_5))
                      }), 128)),
                      (taxRateList.value.length === 0)
                        ? (_openBlock(), _createElementBlock("tr", _hoisted_8, [
                            _createElementVNode("td", _hoisted_9, [
                              _createVNode(_component_v_icon, { color: "grey" }, {
                                default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                                  _createTextVNode("mdi-percent-outline", -1)
                                ]))]),
                                _: 1
                              }),
                              _cache[17] || (_cache[17] = _createElementVNode("span", null, "세금 요율 데이터 없음", -1))
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                _cache[19] || (_cache[19] = _createElementVNode("div", { class: "rate-info" }, [
                  _createElementVNode("p", null, [
                    _createElementVNode("strong", null, "※ 요율 입력 안내")
                  ]),
                  _createElementVNode("ul", null, [
                    _createElementVNode("li", null, "국민연금, 건강보험, 고용보험, 장기요양, 산재보험, 실업급여: 소수점 형태로 입력 (예: 4.5% → 0.045)"),
                    _createElementVNode("li", null, "최저시급: 원 단위로 입력 (예: 9,860원 → 9860)"),
                    _createElementVNode("li", null, "인건비비율: 소수점 형태로 입력 (예: 60% → 0.6)")
                  ])
                ], -1))
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, { class: "dialog-actions" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  variant: "text",
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (dialog.value = false))
                }, {
                  default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                    _createTextVNode("취소", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_v_btn, {
                  color: "primary",
                  variant: "elevated",
                  onClick: saveTaxRates,
                  loading: saving.value
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, { class: "mr-1" }, {
                      default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                        _createTextVNode("mdi-content-save", -1)
                      ]))]),
                      _: 1
                    }),
                    _cache[22] || (_cache[22] = _createTextVNode(" 저장 ", -1))
                  ]),
                  _: 1
                }, 8, ["loading"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_snackbar, {
      modelValue: snackbar.value.show,
      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((snackbar.value.show) = $event)),
      color: snackbar.value.color,
      timeout: 3000
    }, {
      actions: _withCtx(() => [
        _createVNode(_component_v_btn, {
          variant: "text",
          onClick: _cache[10] || (_cache[10] = ($event: any) => (snackbar.value.show = false))
        }, {
          default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
            _createTextVNode("닫기", -1)
          ]))]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(snackbar.value.message) + " ", 1)
      ]),
      _: 1
    }, 8, ["modelValue", "color"])
  ]))
}
}

})